import { Divider } from '@mui/material';
import { CurrentYearDocuments } from './CurrentYearDocuments';
import { PastYearsDocuments } from './PastYearsDocuments';
import { useIsDesktop } from 'Hooks';
import { MobileViewDocuments } from './MobileViewDocuments';
import { useContext } from 'react';
import { DocumentsContext } from 'Context/DocumentsContext';
import { AdvancedFilterResults } from './AdvancedFilterResults';

export const AllDocuments = () => {
  const { filter } = useContext(DocumentsContext);
  const isDesktop = useIsDesktop();

  return (
    <>
      {isDesktop ? (
        <>
          {filter.advancedFilterActive ? (
            <AdvancedFilterResults />
          ) : (
            <>
              <CurrentYearDocuments />
              <Divider
                sx={{
                  borderColor: '#A6ACBC',
                  opacity: '50%',
                  m: '40px 0',
                }}
              />
              <PastYearsDocuments />
            </>
          )}
        </>
      ) : (
        <MobileViewDocuments />
      )}
    </>
  );
};
